module.exports = __webpack_public_path__ + "img/9788946417410.e0ef4d24.jpg";